<template>

    <div v-if="loaded">

        <h2>Abonnemang & avtal</h2>

        <div class="new-list-group contract">

            <div class="new-list-group-item new-list-group-header no-decoration">

                <div class="row g-3">
                    <div class="col-5"><span>Abonnemang</span></div>
                    <div class="col-2"><span>Startdatum</span></div>
                    <div class="col-2"><span>Startavg.</span></div>
                    <div class="col-2"><span>Status</span></div>
                    <div class="col-3"><span>Signerat av</span></div>
                    <div class="col-2"><span>Avtalsmall</span></div>
                    <div class="col-3"><span>Signerat avtal</span></div>
                    <div class="col-2"><span>Slutdatum</span></div>
                    <div class="col-3"><span>Uppsägning</span></div>
                </div>

            </div>

            <contract-row
                :key="contract.id"
                :contract="contract"
                :contracts="company.contracts"
                v-for="contract in company.contracts"
                @refresh="fetch()"
                />

            <contract-row-new
                :company="company"
                :draftContract="draftContract"
                :contracts="company.contracts"
                :subscriptions="subscriptions"
                :admins="admins"
                @refresh="fetch()"
            />
        </div>

        <h2 class="mt-14 mb-2">Skicka e-post till avtalsansvarig</h2>
        <div class="custom-info mb-4 w-50">Här kan du skicka välkomstmail och mail om abonnemanget ändras eller avslutas. Mailen skickas till kontaktpersoner under Arbetsplatser. Tänk på att fylla på kontaktpersoner med e-postadress under Arbetsplatser, innan välkomstmailet skickas.
        </div>
        <div class="alert alert-warning mb-4 w-50" role="alert" v-if="!hasWorkplaceContacts">
            En giltig e-postadress saknas för avtalskontakten. Börja med att lägga in kontaktpersoner med e-postadress under Arbetsplatser.
        </div>

        <div class="row pt-4" v-if="hasWorkplaceContacts">
            <contract-send-welcome-email
                :company="company"
                @success="fetch()"
            />
            <contract-send-contract-changed-email
                :company="company"
                @success="fetch()"
            />
            <contract-send-contract-cancelled-email
                :company="company"
                @success="fetch()"
            />
        </div>

    </div>

</template>

<script>
import axios from 'axios'

import ContractRowNew from './contract-row-new'
import ContractRow from './contract-row'
import ContractSendWelcomeEmail from './contract-send-welcome-email'
import ContractSendContractChangedEmail from './contract-send-contract-changed-email'
import ContractSendContractCancelledEmail from './contract-send-contract-cancelled-email'

export default {

    components: {
        ContractRow,
        ContractRowNew,
        ContractSendWelcomeEmail,
        ContractSendContractChangedEmail,
        ContractSendContractCancelledEmail
    },

    props: {
        company_id: {
            required: true
        }
    },

    data () {
        return {
            company: null,
            draftContract: null,
            admins: [],
            subscriptions: [],
            hasWorkplaceContacts: false,
            loaded: false
        }
    },

    created () {
        this.fetch()
    },

    methods: {
        fetch () {
            axios.get('/companies/' + this.company_id + '/tabContract')
                .then(response => {
                    this.company = response.data.company
                    this.draftContract = response.data.draftContract
                    this.admins = response.data.admins
                    this.subscriptions = response.data.subscriptions
                    this.hasWorkplaceContacts = response.data.hasWorkplaceContacts
                    this.loaded = true
                })
                .catch(error => {
                    console.log(error)
                })
        }
    }

}
</script>
